import { render, staticRenderFns } from "./TrumbowygContainer.vue?vue&type=template&id=e0517b90&scoped=true"
import script from "./TrumbowygContainer.vue?vue&type=script&lang=js"
export * from "./TrumbowygContainer.vue?vue&type=script&lang=js"
import style0 from "./TrumbowygContainer.vue?vue&type=style&index=0&id=e0517b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0517b90",
  null
  
)

export default component.exports